import React, {useState, useRef} from 'react';
import ImageGallery from 'react-image-gallery';
import TnWebCamBottom from './TnWebCamBottom';
import { useDispatch, useSelector } from 'react-redux';
import { setRangeValues, setCameraInterval, setDateSelected, setIsSliderPlayings } from '../../actions/webcamAction';
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import PlayPause from '../PlayPause';
import Language from './../../language/language.json';
import de from 'date-fns/locale/de';
registerLocale('de', de);
//setDefaultLocale('de');

const TnWebCamGallery = (props) => {
    //console.log('from TnWebCamGallery',props);
    const camid = props.camid;
    const cameraGallery = useRef({});

    const webcam = useSelector((store)=>store.webcam);

    const dispatch = useDispatch();

    var {images, 
        rangeValues,
        rangeSettings,
        cameraInterval,
        dateSelected, 
        activeCamera,
        isSidebar} = webcam;

    const MAX = 100;    

    const changeCamGalleryImage = (values, camid) => {
        if('cam'+camid in cameraGallery.current){
            values = parseInt(values);
            if(typeof images['cam'+camid][values] !== 'undefined'){
                cameraGallery.current['cam'+camid]?.slideToIndex(values);
            }
        }
    }   
    
    const getBackgroundSize = (camid) => {
        return {
            backgroundSize: `${(rangeValues['cam' + camid] * 100) / MAX}% 100%`,
        };
    };

    //console.log("props.address", props.address);
    return(
        <>
            <ImageGallery 
                ref={(e)=>{cameraGallery.current['cam'+camid] = e}}
                showFullscreenButton ={false}
                accessibility={false}
                showThumbnails={false} 
                showNav={false}
                slideDuration={500}
                slideInterval={1500}
                items={images['cam'+camid]} 
                useTranslate3D={false}
                disableSwipe={true}
                onSlide={(currentIndex)=>{dispatch(setRangeValues(currentIndex, camid))}}
                startIndex={Object.keys(images['cam'+camid]).length-1}
                renderPlayPauseButton={(onClick, isPlaying) => {
                    
                    return (
                        <>
                            {!isSidebar ? 
                            <div className='camera-interval-control'>
                                <select id={'cam'+camid} 
                                    className='cameraintervalselect' 
                                    value={cameraInterval['cam'+camid]}
                                    onChange={(e)=>dispatch(setCameraInterval(dispatch, e.target.value, camid))}>
                                        <option value='daily'>{Language[props.lang].daily}</option>
                                        <option value='week'>{Language[props.lang].weekly}</option>
                                        <option value='month'>{Language[props.lang].monthly}</option>
                                        <option value='year'>{Language[props.lang].yearly}</option>
                                </select>
                                {
                                    cameraInterval['cam'+camid] === 'daily' ? 
                                    <>
                                        <DatePicker 
                                            locale={props.lang}
                                            selected={dateSelected['cam'+camid]}
                                            onChange={(date)=>dispatch(setDateSelected(dispatch, date, camid))}
                                            maxDate={new Date()}
                                            />
                                    </>
                                    : <p className="time-label">{
                                        images['cam' + camid][rangeValues['cam' + camid]]?.originalTitle
                                        }</p>
                                }
                            </div>
                            : <></>
                            }
                            <div className='slide-bottom-content'>
                                <div className='slide-play-control'>
                                    <PlayPause
                                        onClick={() => { onClick(); dispatch(setIsSliderPlayings(isPlaying, camid, cameraGallery.current['cam'+camid]));}}
                                        isPlaying={isPlaying}

                                    />
                                    {cameraInterval['cam'+camid] === 'daily' ? 
                                        <>
                                        <div className="main-range-wrap">
                                        <input type="range"
                                            min="0"
                                            max={rangeSettings['cam' + camid]['max']}
                                            step={rangeSettings['cam' + camid]['step']}
                                            onChange={(e) => {dispatch(setRangeValues(e.target.value, camid)); changeCamGalleryImage(e.target.value, camid);}}
                                            style={getBackgroundSize(camid)}
                                            value={rangeValues['cam' + camid]} />
                                            <p className='current-range-time' style={{left: `calc(${(rangeValues['cam' + camid]*100/rangeSettings['cam' + camid]['max'])-0}% + (${10 - ((rangeValues['cam' + camid]*100/rangeSettings['cam' + camid]['max']) * 0.2)}px))`}} >{
                                            images['cam' + camid][rangeValues['cam' + camid]]?.originalTitle
                                            }
                                        </p>
                                        </div>
                                        </>
                                        : ''
                                    }    
                                </div>
                                {camid === activeCamera ? 
                                <>
                                <TnWebCamBottom lang={props.lang} accomodation={props.accomodation} 
                                                                copyrightlink={props.copyrightlink}
                                                                copyrighttext={props.copyrighttext}
                                                                copyrighttitle={props.copyrighttitle}
                                                                nofollow={props?.nofollow}/>
                                </>
                                : ''
                                }
                            </div>
                            
                        </>
                    )
                    }
                }   
                />
        </>
    )
}


export default TnWebCamGallery;